// extracted by mini-css-extract-plugin
module.exports = {"usageRepairHolder":"UsageAdmin_usageRepairHolder__2V0D8","attendeeSelectHolder":"UsageAdmin_attendeeSelectHolder__3FQT3"};